import { Stack } from '@mantine/core'
import DealDetailsInfo from './deal-details-info'



export default function DealPage() {

    return (
        <Stack w="100%">
            <DealDetailsInfo />
        </Stack>
    )
}